import { createContext, useEffect, useLayoutEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { WalletConnectProvider } from './lib/web3/wagmiProvider'
import { StakingProvider } from './lib/contexts/StakingContext'

import { ScrollTop } from './lib/hooks/useScrollTop'
import { usePageTracking } from './lib/hooks/useAnalytics'
import { getScreenSize } from './lib/helpers'

import { Header, Footer } from './lib/components'
import './App.scss'

export const AppContext = createContext(null)

const App = () => {
  const [fullPageContent, setFullPageContent] = useState(false)
  const [shownHeader, setShownHeader] = useState(true)
  const location = useLocation()

  const [screenSize, setScreenSize] = useState(() => {
    return getScreenSize()
  })

  // Initialize analytics and track page views
  usePageTracking()

  // The redesigned homepage ships with its own Figma-styled header + footer, so
  // hide the global Header/Footer on those routes (incl. waitlist deep links).
  const homeRoutes = [
    '/',
    '/protocol',
    '/index.html',
    '/ai-fast-track-waitlist',
    '/open-campus-web-app-waitlist',
  ]
  const isHomePage = homeRoutes.includes(location.pathname)

  // The OC Achievements page reuses the redesigned Figma-styled pill header (it
  // renders its own <HomeHeader />), so hide the global Header there too. The
  // global Footer still shows on that route.
  const hideGlobalHeader = isHomePage || location.pathname === '/oc-achievements'

  useLayoutEffect(() => {
    setShownHeader(true)
  }, [setShownHeader])

  useEffect(() => {
    if (!shownHeader) {
      setShownHeader(true)
    }
    if (!!fullPageContent) {
      setFullPageContent(false)
    }
  }, [location])

  useEffect(() => {
    const windowSizeListener = () => {
      setScreenSize(getScreenSize())
    }
    window.addEventListener('resize', windowSizeListener)

    return () => {
      window.removeEventListener('resize', windowSizeListener)
    }
  }, [])

  return (
    <WalletConnectProvider>
      <StakingProvider>
        <ScrollTop />
        <AppContext.Provider value={{ screenSize }}>
          <div className="app-root">
            {!hideGlobalHeader && <Header />}
            <div className="app-body">
              <Outlet context={{ shownHeader, setShownHeader }} />
            </div>
            <div id="supplies-bg-container" />
            {!isHomePage && <Footer />}
          </div>
        </AppContext.Provider>
      </StakingProvider>
    </WalletConnectProvider>
  )
}

export default App
